import React from 'react'
import {useApiSession} from "../ApiSession";

export default ({children, refz}) => {

    const session = useApiSession()

    return <nav
        ref={refz}
        id="navbar"
        className="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600"
    >
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
            <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">Registre Vasculites</span>
            </a>
            <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse"></div>
            <div className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1">
                <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                    {
                        session && session.isLoggedIn && <>
                            <li>
                                <a href="/"
                                   className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                                   aria-current="page">/</a>
                            </li>
                            <li>
                                <a href="/dossiers"
                                className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                                aria-current="page">Dossiers</a>
                            </li>
                        </>
                    }
                    {
                        session && session.isLoggedIn && <li>
                        <a onClick={() => {
                            session.logout()
                        }}
                           className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                           style={{cursor: "default"}}
                           aria-current="page">Logout</a>
                    </li>
                    }
                    {
                        session && session.data && session.data.is_admin && <li>
                        <a className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                           style={{cursor: "default"}}
                           href={"/admin"}
                           aria-current="page">Admin</a>
                    </li>
                    }
                </ul>
            </div>
        </div>

        <div className="flex flex-row">
            <div className={"basis-1/5"}></div>
            <div className={"basis-3/5"}>
                {children}
            </div>
            <div className={"basis-1/5"}></div>
        </div>
    </nav>
}
